import React, { useState, useEffect } from 'react';
import CardsOrganizational from '../components/CardsOrganizational'
import { Row, Col } from "react-bootstrap";
import Charts from '../components/Charts';
import RiskAnalysisTable from '../components/RiskAnalysisTable';
import DatePicker from "../components/DatePicker";
import BaseTablesingle from "../components/BaseTablesingle";
import CardsTeamPods from "../components/CardsTeamPods"
import Radio from "../components/Radio";
import { useParams } from "react-router-dom";
import { fetchData, fetchDataPost, checkAccessToken } from "../services/apiService";
import { getPopupTableColumnName } from '../utils/commonUtils';
import SimpleSkeleton from "../skeletons/SimpleSkeleton";
import { Tabs, Tab } from "react-bootstrap";
import BaseTable from "../components/BaseTable";
import CardSkeleton from "../skeletons/CardSkeleton";
import { useMicrosoftAuth } from "../context/MicrosoftAuthContext";
import MetricsConsideredModal from '../components/MetricsConsideredModal';
import OrganizationalMetricsModal from '../components/OrganizationalMetricsModal';
import { useOrganizationalMetricsModal } from '../hooks/useOrganizationalMetricsModal';

// import { FaCircle, FaHome } from "react-icons/fa"; // Using react-icons for icons

const SinglePods = ({ isOpen, toggle }) => {
    const { userTeamData } = useMicrosoftAuth();
    const { id } = useParams();
    const [podData, setpodData] = useState([]);
    const [podDataLoading, setpodDataLoading] = useState(false);

    const startOfMonth = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1));
    const endOfMonth = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0));
    const defaultStartDate = startOfMonth;
    const defaultEndDate = endOfMonth;

    const [dateRange, setDateRange] = useState([defaultStartDate, defaultEndDate]);
    const [startDate, endDate] = dateRange;

    const [allBranchesData, setAllBranchesData] = useState([]);
    const [allBranchesDataLoading, setAllBranchesDataLoading] = useState(false);

    const [objectives, setObjectives] = useState([]);
    const [objectivesCountLoading, setObjectivesCountLoading] = useState(true);

    const [greenMeticsCount, setGreenMeticsCount] = useState(0);
    const [yellowMeticsCount, setYellowMeticsCount] = useState(0);
    const [redMeticsCount, setRedMeticsCount] = useState(0);
    const [dateRangeData, setDateRangeData] = useState([]);
    const [metricsDateRangeData, setMetricsDateRangeData] = useState([]);
    const [metricBranchDataRangeData, setMetricBranchDataRangeData] = useState([]);
    const [teamPodMembersRangeData, setTeamPodMembersRangeData] = useState([]);

    const [organizationalEvaluationLoading, setOrganizationalEvaluationLoading] = useState(false);
    const [organizationalEvaluation, setOrganizationalEvaluation] = useState([]);

    const [activeObjectiveTab, setActiveObjectiveTab] = useState(0);
    const [activeObjectiveName, setActiveObjectiveName] = useState('');
    const [frequency, setFrequency] = useState('weekly');

    const organizationHeaders = ["Metric", "Baseline", "Target", "Result",  "Risk Level"];
    
    const { modalState: orgMetricsModalState, handleMetricsCardClick: handleOrgMetricsCardClick, closeModal: closeOrgMetricsModal } = useOrganizationalMetricsModal();
    const [showMetricsModal, setShowMetricsModal] = useState(false);

    const [metrics, setMetrics] = useState([]);
    const [activeMetric, setActiveMetric] = useState({});

    const handleMetricsCardClick = () => setShowMetricsModal(true);

    const handleOrganizationalMetricsCardClick = (cardType) => {
        handleOrgMetricsCardClick(cardType, {
            date: startDate || new Date(),
            title: activeObjectiveName
        });
    };

    const handleDateRangeChange = (newDateRange) => {
        // Create dates in UTC using Date.UTC()
        const startOfMonth = new Date(Date.UTC(newDateRange.startYear, newDateRange.startMonth - 1, 1));
        const endOfMonth = new Date(Date.UTC(newDateRange.endYear, newDateRange.endMonth, 0));
    
        // The rest of your function remains the same
        newDateRange = [startOfMonth, endOfMonth];
        setDateRange(newDateRange);
        const [startDate, endDate] = newDateRange;
        if (startDate && endDate) {
            console.log("both true");
            getOrganizationalEvaluation(activeObjectiveTab, startDate, endDate, frequency);
        }
    };
    async function getTeamsPodWithUsers() {
        setpodDataLoading(false);
        try {
            var post_data = {};
            post_data.podID = id;
            post_data.user_team_id = userTeamData?.id;
            post_data.user_role_id = userTeamData?.user_role_id;
            var user_group = [];
            userTeamData?.user_group?.forEach(group => {
                user_group.push(group);
            });
            post_data.user_group = user_group;
            const result = await fetchDataPost('getTeamsPodWithUsers', post_data, controllerRef);
            if (result != null) {
                setpodData(result);
            }
        } catch (err) {
            console.log(err.message);
        } finally {
            setpodDataLoading(true);
        }
    }

    async function getObjectives() {
        try {
            const result = await fetchData('getObjectives', controllerRef);

            const [startDate, endDate] = dateRange;
            if (result != null) {
                setObjectives(result);
                if (result.length > 0) {
                    setActiveObjectiveTab(result[0].id);
                    const activeObjective = result.find(objective => objective.id === result[0].id);
                    setActiveObjectiveName(activeObjective ? activeObjective.name : '');
                    getOrganizationalEvaluation(result[0].id, startDate, endDate, frequency);
                }
            }
        } catch (err) {
            console.log(err.message);
        } finally {
            setObjectivesCountLoading(true);
        }
    }
    
    async function getOrganizationalEvaluation(activeObjectiveTab, startDate, endDate, frequency = 'weekly') {
        setOrganizationalEvaluationLoading(true);
        try {
            var post_data = {};
            if (startDate) {
                post_data.startDate = startDate;
            }
            if (endDate) {
                var endDateWithAdjustedTime = new Date(endDate);
                endDateWithAdjustedTime.setUTCHours(23, 59, 59, 999);
                post_data.endDate = endDateWithAdjustedTime;
            }
            post_data.objectiveID = activeObjectiveTab;
            post_data.id = id;
            post_data.organization = "singlepods";
            post_data.user_team_id = userTeamData?.id;
            post_data.user_role_id = userTeamData?.user_role_id;
            var user_group = [];
            userTeamData?.user_group?.forEach(group => {
                user_group.push(group);
            });
            post_data.user_group = user_group;
            post_data.frequency = frequency;
            const result = await fetchDataPost('getOrganizationalEvaluation', post_data, controllerRef);
            console.log(result);
            if (result != null) {
                setMetrics(result.showMetrics);
                if(result.showMetrics.length>0){
                   setActiveMetric(result.showMetrics[0]);
                }
                setGreenMeticsCount(result.summary.greenMeticsCount??0);
                setYellowMeticsCount(result.summary.yellowMeticsCount??0);
                setRedMeticsCount(result.summary.redMeticsCount??0);
                setDateRangeData(result.dateRangeData);
                setMetricsDateRangeData(result.singleMetricsData);
                setMetricBranchDataRangeData(result.singleMetricBranchData);
                setTeamPodMembersRangeData(result.singleMetricTeamPodMembersData);
                
            }
            setOrganizationalEvaluationLoading(false);
        } catch (err) {
            console.log("err.message", err.message);
            // Don't set loading to false if request was cancelled
            if (err.name === 'AbortError' || err.message === 'canceled') {
                console.log('Request was cancelled');
                // Don't update loading state for cancelled requests
            } else {
                // Keep loading state as true for other errors
                console.log('Request failed with error');
                setOrganizationalEvaluationLoading(true);
            }
        } 
    }
    var controllerRef = new AbortController();
    const loadData = async () => {
        await checkAccessToken(controllerRef);
        getTeamsPodWithUsers();
        getObjectives();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className='bg-white p-30-19'>
            {/* Pod Header and Team Members Container */}
            <div className="pod-header-container">
                <div className="pod-header-card">
                    {/* Header Section */}
                    <div className="pod-header-content">
                        <div className="pod-title-section">
                            <div className="pod-title-row">
                                <div className="pod-icon-wrapper">
                                    <img 
                                        src="/assets/icons/teams.svg" 
                                        alt="Pod Icon" 
                                        className="pod-icon"
                                    />
                                </div>
                                <div className="pod-title-text">
                                    <span className="pod-name">{podData.name || 'Central Tower'}</span>
                                </div>
                            </div>
                        </div>
                        <div className="pod-team-count-section">
                            <div className="team-count-badge">
                                <div className="team-count-icon">
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_1_19499)">
                                            <path d="M4 9.62201L1.198 6.82001C0.724667 6.34668 0.502 5.72468 0.429333 5.10868C0.154667 4.83401 0 4.46068 0 4.07201V1.58001C0 0.963343 0.52 0.468009 1.146 0.509343C1.41267 0.526676 1.66067 0.650676 1.85 0.839343L2.85467 1.84068H7.18467C7.618 1.84068 7.998 2.19468 8 2.62734C8.002 3.05934 7.65267 3.41068 7.22 3.41134H6.274L8.06867 5.20601C7.52467 5.27934 7.04467 5.55868 6.73 5.97868C6.422 5.85801 6.07733 5.81068 5.71667 5.86001C4.72333 5.99734 3.99933 6.87534 3.99933 7.87801L4 9.62201ZM14.6707 0.502676L13.7427 0.500009C13.3873 0.498676 13.0467 0.639343 12.7953 0.890676L12.102 1.58401C11.486 1.65601 10.864 1.87934 10.3907 2.35268C10.3907 2.35268 8.88533 3.94001 8.79133 4.04334L12.1287 7.38068C12.586 7.83934 12.5853 8.64334 12.5853 8.64334L13.7993 7.42934V8.37534C13.7993 8.80601 14.1487 9.15534 14.5793 9.15534C15.01 9.15534 15.3593 8.80601 15.3593 8.37534L15.334 4.00934L15.512 3.83134C15.8247 3.51868 16 3.09468 16 2.65268V1.83601C16 1.10134 15.4053 0.505343 14.6707 0.502676ZM10.6667 7.84001C10.2987 7.84001 10 8.13868 10 8.50668V10.6733C10 10.9493 9.776 11.1733 9.5 11.1733C9.224 11.1733 9 10.9493 9 10.6733V7.17334C9 6.80534 8.70133 6.50668 8.33333 6.50668C7.96533 6.50668 7.66667 6.80534 7.66667 7.17334V10.6733C7.66667 10.9493 7.44267 11.1733 7.16667 11.1733C6.89067 11.1733 6.66667 10.9493 6.66667 10.6733V7.84001C6.66667 7.47201 6.368 7.17334 6 7.17334C5.632 7.17334 5.33333 7.47201 5.33333 7.84001V12.7373L4.66467 12.0687C4.36 11.764 3.86667 11.764 3.562 12.0687C3.25733 12.3733 3.25733 12.8667 3.562 13.1713L6.20667 15.7493C6.70467 16.2347 7.37267 16.5067 8.068 16.5067H10C10.368 16.5067 10.6667 16.208 10.6667 15.84V15.5867C11.0767 15.118 11.3333 14.5113 11.3333 13.84V8.50734C11.3333 8.13934 11.0347 7.84001 10.6667 7.84001Z" fill="white"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1_19499">
                                                <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div className="team-count-text">
                                    <span className="team-count-label">Team Members: {podData.users?.length?.toString().padStart(2, '0') || '03'}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Team Members Cards */}
                    <Row className='g-3 w-100'>
                        {podDataLoading ? (
                            <>
                                {podData.users?.map((item, index) => (
                                    <Col key={index} sm={12} md={6} lg={4} className='mb-24 d-flex'>
                                        <CardsTeamPods
                                            CardColor="bg-white"
                                            name={item.name}
                                            role={item.role}
                                            secondaryRole={item.secondaryRole}
                                            phone={item.phone}
                                            email={item.email}
                                            PageRoute={"/teams_pods/singlepodmember/" + item.id + '/' + item.type}
                                            isTeamLead={index === 0}
                                        />
                                    </Col>
                                ))}
                            </>
                        ) : (
                            <CardSkeleton rows={4} columns={3} />
                        )}
                    </Row>
                </div>
            </div>

            {/* Analytics Section */}
            <div className='organizational-analytics-container mb-24'>
                <div className='organizational-analytics-title'>{podData.name || 'Pod'} Analytics</div>

                <div className='analytics-controls-container'>
                    <div className='analytics-section'>
                        <div className='objective-controls'>
                            <div className='objective-label'>Select Objective:</div>
                    {objectives.map((item) => (
                                <button key={`${item.id}`} className={`objective-tab ${activeObjectiveTab == item.id ? 'active' : ''}`}
                                    onClick={() => { const [s, e] = dateRange; setActiveObjectiveTab(item.id); const obj = objectives.find(o=>o.id==item.id); setActiveObjectiveName(obj?obj.name:'NA'); getOrganizationalEvaluation(item.id, s, e, frequency); }}>
                                    {item.name}
                                </button>
                            ))}
                    </div>

                    <div className='date-range-controls'>
                        <div className='date-picker-container'>
                            <DatePicker views={['year', 'month']} openTo="month" datetitle={'text-12 fw-500 text-4E4E4E'} datepicker={"bg-black text-white"} icon={"calendar-dark"} startDate={startDate} endDate={endDate} handleDateRangeChange={handleDateRangeChange} />
                        </div>
                    </div>
                </div>

                    <div className='metrics-cards-container'>
                        <CardsOrganizational isMetricsCard={true} totalCount={metrics.length} CardLabel="Metrics Considered" onMetricsCardClick={handleMetricsCardClick} 
                            isLoading={organizationalEvaluationLoading}/>
                        <CardsOrganizational isMetricsCard={true} metricsCardType="green" totalCount={greenMeticsCount} CardLabel="Green Level" onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading} />
                        <CardsOrganizational isMetricsCard={true} metricsCardType="amber" totalCount={yellowMeticsCount} CardLabel="Amber Level" onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading} />
                        <CardsOrganizational isMetricsCard={true} metricsCardType="red" totalCount={redMeticsCount} CardLabel="Red Level" onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading} />
                </div>
            </div>
            </div>

            {/* Risk Analysis Section */}
            <div className='risk-analysis-group'>
                <Charts
                    objectiveName={activeObjectiveName}
                    metricsCount={metrics.length}
                    objectivesCount={objectives.length}
                    greenMeticsCount={greenMeticsCount}
                    yellowMeticsCount={yellowMeticsCount}
                    redMeticsCount={redMeticsCount}
                    dateRangeData={dateRangeData}
                    isDataLoading={organizationalEvaluationLoading}
                    activeMetric={activeMetric}
                    allMetric={metrics}
                    dateRange={dateRange}
                    onMetricChange={(metric) => setActiveMetric(metric)}
                    onDataChange={(data) => setActiveMetric((Array.isArray(data) ? data : []).map(item => ({ date: item.date, target: item.target, result: item.result, riskLevel: item.risk })))}
                    onFrequencyChange={(newFrequency) => { setFrequency(newFrequency); const [s, e] = dateRange; getOrganizationalEvaluation(activeObjectiveTab, s, e, newFrequency); }}
                />

                <RiskAnalysisTable
                    isDataLoading={organizationalEvaluationLoading}
                    dateRangeData={dateRangeData}
                    activeMetric={activeMetric}
                    metricBranchDataRangeData={teamPodMembersRangeData}
                    dateRange={dateRange}
                    date={startDate && endDate ?
                        `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                        ''
                    }
                    columnName={"Team Members"}
                />
            </div>

            {/* Metrics Considered Modal */}
            <MetricsConsideredModal
                show={showMetricsModal}
                onHide={() => setShowMetricsModal(false)}
                objective={activeObjectiveName}
                metricsDateRangeData={metricsDateRangeData}
                isDataLoading={organizationalEvaluationLoading}
                date={startDate && endDate ?
                    `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                    ''
                }
            />

            {/* Organizational Metrics Modal */}
            <OrganizationalMetricsModal
                show={orgMetricsModalState.show}
                onHide={closeOrgMetricsModal}
                data={metricsDateRangeData}
                title={orgMetricsModalState.title}
                cardType={orgMetricsModalState.cardType}
                date={startDate && endDate ?
                    `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                    ''
                }
            />
        </div>
    );
};

export default SinglePods;
